export const POPUP_ATTACHMENT_CONTACT = "POPUP_ATTACHMENT_CONTACT";
export const POPUP_CONTACT_IMPORT = "POPUP_CONTACT_IMPORT";
export const POPUP_EDIT_CONTACT = "POPUP_EDIT_CONTACT";
export const POPUP_CAMERA = "POPUP_CAMERA";
export const POPUP_CREATE_CONVERSATION = "POPUP_CREATE_CONVERSATION";
export const POPUP_CREATE_GROUP_CHANNEL = "POPUP_CREATE_GROUP_CHANNEL";
export const AVATARS_POPUP_GALLERY = "AVATARS_POPUP_GALLERY";
export const MESSAGES_POPUP_GALLERY = "MESSAGES_POPUP_GALLERY";
export const POPUP_PROFILE_IVAND = "POPUP_PROFILE_IVAND";
export const POPUP_ROOM = "POPUP_ROOM";
export const POPUP_NEAR_BY = "POPUP_NEAR_BY";
export const POPUP_BUY_CHARGE = "POPUP_BUY_CHARGE";
export const POPUP_ELECTRIC_BILL = "POPUP_ELECTRIC_BILL";
export const POPUP_MAP = "POPUP_MAP";
export const POPUP_ADD_NEW_COMMENT = "POPUP_ADD_NEW_COMMENT";
export const POPUP_EDIT_MY_BILLS = "POPUP_EDIT_MY_BILLS";
export const POPUP_ADD_MY_BILLS = "POPUP_ADD_MY_BILLS";
export const POPUP_BILL_INQUIRY = "POPUP_BILL_INQUIRY";
export const POPUP_BRANCH_INFO = "POPUP_BRANCH_INFO";
export const POPUP_IGASHT_TICKET = "POPUP_IGASHT_TICKET";
export const POPUP_IGASHT_LOCATION_SEARCH = "POPUP_IGASHT_LOCATION_SEARCH";
export const POPUP_IGASHT_BUY_TICKET = "POPUP_IGASHT_BUY_TICKET";
export const POPUP_IGASHT_TICKET_LIST = "POPUP_IGASHT_TICKET_LIST";
export const POPUP_IGASHT_TICKET_QRCODE = "POPUP_IGASHT_TICKET_QRCODE";
export const POPUP_MY_BILLS = "POPUP_MY_BILLS";
export const POPUP_CONTACTS = "POPUP_CONTACTS";
export const POPUP_ROOM_ADD_MEMBER = "POPUP_ROOM_ADD_MEMBER";
export const POPUP_ROOM_ADMIN_PERMISSION = "POPUP_ROOM_ADMIN_PERMISSION";
export const POPUP_ROOM_CHANNEL_EDIT = "POPUP_ROOM_CHANNEL_EDIT";
export const POPUP_ROOM_CHANNEL_TYPE = "POPUP_ROOM_CHANNEL_TYPE";
export const POPUP_ROOM_FORWARD = "POPUP_ROOM_FORWARD";
export const POPUP_ROOM_MEMBER_LIST = "POPUP_ROOM_MEMBER_LIST";
export const POPUP_ROOM_PERMISSION = "POPUP_ROOM_PERMISSION";
export const POPUP_ROOM_REPORT = "POPUP_ROOM_REPORT";
export const POPUP_SETTING = "POPUP_SETTING";
export const POPUP_SETTING_CHAT_SETTING = "POPUP_SETTING_CHAT_SETTING";
export const POPUP_SETTING_NOTIFICATION = "POPUP_SETTING_NOTIFICATION";
export const POPUP_SETTING_PRIVACY = "POPUP_SETTING_PRIVACY";
export const POPUP_SETTING_PRIVACY_BLOCKED = "POPUP_SETTING_PRIVACY_BLOCKED";
export const POPUP_SETTING_PRIVACY_SESSIONS = "POPUP_SETTING_PRIVACY_SESSIONS";
export const POPUP_SETTING_PRIVACY_VERIFICATION = "POPUP_SETTING_PRIVACY_VERIFICATION";
export const POPUP_SETTING_PRIVACY_VERIFICATION_SET = "POPUP_SETTING_PRIVACY_VERIFICATION_SET";
export const POPUP_SETTING_PROFILE = "POPUP_SETTING_PROFILE";
export const POPUP_SETTING_PROFILE_USERNAME = "POPUP_SETTING_PROFILE_USERNAME";
export const POPUP_SETTING_PROFILE_PHONE = "POPUP_SETTING_PROFILE_PHONE";
export const POPUP_SETTING_PROFILE_PHONE_VERIFY = "POPUP_SETTING_PROFILE_PHONE_VERIFY";
export const POPUP_SETTING_STORAGE = "POPUP_SETTING_STORAGE";
export const POPUP_STICKER_ADD = "POPUP_STICKER_ADD";
export const POPUP_STICKER_GROUP = "POPUP_STICKER_GROUP";
export const POPUP_SHARED_MEDIA = "POPUP_SHARED_MEDIA";
export const POPUP_USERNAME = "POPUP_USERNAME";
export const POPUP_UPDATE = "POPUP_UPDATE";
export const POPUP_CONVERT_TO_GROUP = "POPUP_CONVERT_TO_GROUP";
export const POPUP_RECEIPT = "POPUP_RECEIPT";
export const POPUP_IVAND_HISTORY = "POPUP_IVAND_HISTORY";
export const POPUP_MAIN_VIRTUAL_GIFT = "POPUP_MAIN_VIRTUAL_GIFT";
export const POPUP_VIRTUAL_GIFT_LIST = "POPUP_VIRTUAL_GIFT_LIST";
export const POPUP_MY_GIFT_LIST = "POPUP_MY_GIFT_LIST";
export const POPUP_ACTIVATED_GIFT_LIST = "POPUP_ACTIVATED_GIFT_LIST";
export const POPUP_GIFT_CARD_DETAIL = "POPUP_GIFT_CARD_DETAIL";
export const POPUP_BUY_INTERNET_PACKAGES = "POPUP_BUY_INTERNET_PACKAGES";
export const POPUP_BUY_INTERNET_PACKAGE_LIST = "POPUP_BUY_INTERNET_PACKAGE_LIST";
export const POPUP_FINANCIAL_HISTORY = "POPUP_FINANCIAL_HISTORY";
export const POPUP_FINANCIAL_INFO = "POPUP_FINANCIAL_INFO";
export const POPUP_SHOW_MESSAGE = "POPUP_SHOW_MESSAGE";
export const POPUP_INQUIRY_MCI = "POPUP_INQUIRY_MCI";
export const POPUP_INQUIRY_TELECOM = "POPUP_INQUIRY_TELECOM";
export const POPUP_WALLET_PEC = "POPUP_WALLET_PEC";
export const POPUP_WALLET_PEC_PAYMENT = "POPUP_WALLET_PEC_PAYMENT";
export const POPUP_STORY_GALLERY = "POPUP_STORY_GALLERY";
export const POPUP_STORY_VIEWS = "POPUP_STORY_VIEWS";
export const POPUP_DELETE_ACCOUNT = "POPUP_DELETE_ACCOUNT";
export const ROUTE_LOGIN = `/login`;
export const ROUTE_LOGIN_CODE = `${ROUTE_LOGIN}/code`;
export const ROUTE_LOGIN_NICKNAME = `${ROUTE_LOGIN}/nickname`;
export const ROUTE_LOGIN_PASSWORD = `${ROUTE_LOGIN}/password`;
export const ROUTE_LOGIN_RECOVERY_EMAIL = `${ROUTE_LOGIN}/recovery/email`;
export const ROUTE_LOGIN_RECOVERY_QUESTION = `${ROUTE_LOGIN}/recovery/question`;
export const ROUTE_MESSENGER = `/app`;
export const ROUTE_ROADMAP = `/roadmap`;
export const ROUTE_TEST = `/proto-test-page`;
export const ROUTE_TOO_MANY_SESSION = `/error/sessions`;
export const ROUTE_FILE_PLAYGROUND = `/playground/file`;
export const ROUTE_FILE_STREAM = `/playground/stream`;
export const POPUP_CARD_INFO = "POPUP_CARD_INFO";
export const POPUP_ADD_TO_HS = "POPUP_ADD_TO_HS";
